import { NgModule } from '@angular/core';
import { ForgotPasswordPageModule } from './forgot-password/forgot-password.module';
import { SigninPageModule } from './signin/signin.module';
import { SignupPageModule } from './signup/signup.module';
@NgModule({
  imports: [SignupPageModule, SigninPageModule, ForgotPasswordPageModule],
  exports: [SignupPageModule, SigninPageModule, ForgotPasswordPageModule],
})
export class AuthenticationModule { }
